<script>
    import { setupI18n, _ } from './i18n';
    import { onMount, onDestroy } from 'svelte';

    let timeout;
    onMount(() => {
        timeout = setTimeout(() => {
            window.location.href = cpaUrl;
        }, 7000);
    })

    onDestroy(() => {

    })
    export let locale = 'ru-RU';

    export let headBackgroundColor = '#fff';
    export let headBorderBottomColor = '#A3A3A3';

    export let cpaUrl = 'https://zencpa.ru';

    export let show = false;

    function hide() {
        show = false;
    }

</script>

{#if show}
<div class="zencpa-modal-wrap">
    <div class="zencpa-modal-header" style={`
        background-color: ${headBackgroundColor};
        border-bottom: 1px solid ${headBorderBottomColor};
    `}>
        <div class="title-wrap">
            Зарабатывайте вместе с нами в ZenCpa!
        </div>
        <a href="/nojs.html" class="close-btn-wrap" on:click|preventDefault={hide}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.09659 7.00001L14.7666 1.33001C14.894 1.18122 14.9606 0.989828 14.953 0.79408C14.9455 0.598331 14.8643 0.412646 14.7258 0.274128C14.5873 0.13561 14.4016 0.0544619 14.2059 0.046901C14.0101 0.0393401 13.8187 0.105923 13.6699 0.233343L7.99992 5.90334L2.32993 0.225566C2.18114 0.098145 1.98974 0.0315629 1.79399 0.0391238C1.59825 0.0466847 1.41256 0.127832 1.27404 0.26635C1.13552 0.404868 1.05438 0.590554 1.04682 0.786302C1.03926 0.98205 1.10584 1.17344 1.23326 1.32223L6.90326 7.00001L1.22548 12.67C1.14406 12.7397 1.07793 12.8255 1.03125 12.922C0.984565 13.0185 0.95833 13.1236 0.954193 13.2307C0.950055 13.3379 0.968105 13.4447 1.00721 13.5445C1.04631 13.6443 1.10562 13.7349 1.18142 13.8107C1.25722 13.8865 1.34787 13.9458 1.44767 13.985C1.54748 14.0241 1.6543 14.0421 1.76141 14.038C1.86853 14.0338 1.97363 14.0076 2.07012 13.9609C2.16662 13.9142 2.25242 13.8481 2.32215 13.7667L7.99992 8.09668L13.6699 13.7667C13.8187 13.8941 14.0101 13.9607 14.2059 13.9531C14.4016 13.9456 14.5873 13.8644 14.7258 13.7259C14.8643 13.5874 14.9455 13.4017 14.953 13.2059C14.9606 13.0102 14.894 12.8188 14.7666 12.67L9.09659 7.00001Z" fill="#F9D2D5"/>
            </svg>
        </a>
    </div>
    <div class="zencpa-modal-body">
        <p class="intro-text">
            Теперь раздел партнерской программы находится на сайте zencpa.ru!
            Переходите и начинайте зарабатывать!
        </p>

        <div class="button-wrap">
            <a href={cpaUrl} class="link-btn">Перейти на ZenCpa</a>
        </div>

        <p class="outro-text">
            Вы будете перенаправлены автоматически через 7 секунд.
        </p>
    </div>
</div>
{/if}

<style>
    .zencpa-modal-header {
        padding-top: 20px;
        padding-bottom: 20px;

        color: #6AC8C8;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    .zencpa-modal-body {
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 25px;

        text-align: center;
    }
    .intro-text, .outro-text {
        color: #87878C;
        font-size: 16px;
        font-weight: 300;
        line-height: 25px;
        letter-spacing: 0.24px;
        margin-bottom: 18px;
    }
    .button-wrap {
        margin-bottom: 18px;
    }
    a.link-btn:hover, a.link-btn:focus {
        text-decoration: none;
    }
    .link-btn {
        border-radius: 37.5px;
        background: #6AC8C8;
        box-shadow: 0px 4px 15px 0px rgba(106, 200, 200, 0.60);

        width: 327px;
        height: 43px;

        display: block;
        padding-top: 12px;
        padding-bottom: 12px;

        color: #FFF;
        text-align: center;
        font-size: 14px;

        margin-left: auto;
        margin-right: auto;
    }
    .zencpa-modal-wrap {
        border-radius: 10px;
        background: #FFF;
        border: 1px solid #A3A3A3;

        width: 597px;
        height: 265px;
        overflow: hidden;

        font-family: Roboto;
    }

    @-moz-keyframes spin {
        100% { -moz-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform:rotate(360deg);
        }
    }
    .spinner {
        -webkit-animation:spin 2s linear infinite;
        -moz-animation:spin 2s linear infinite;
        animation:spin 2s linear infinite;
    }


</style>